import React, { useEffect, useState } from 'react';
import Header from '../Header';
import {
    listMyIdps,
    createIdp,
    updateIdpOwner,
    deleteIdp,
    getIdp,
} from '../../api/idps';
import IdpViewModal from '../../components/idp/IdpViewModal';

// Employee’s IDPs — open each in a modal. Create happens in the same modal.
export default function MyIdp() {
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState('');
    const [contract, setContract] = useState(null);
    const [rows, setRows] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [current, setCurrent] = useState(null); // null => create

    async function refresh() {
        setLoading(true); setErr('');
        try {
            const res = await listMyIdps();
            // res: { contract, data: [idps...], meta? }
            setContract(res?.contract ?? null);
            setRows(res?.data ?? []);
        } catch (e) {
            setErr(e?.response?.data?.message || 'Failed to load IDPs.');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => { refresh(); }, []);

    const openCreate = () => {
        setCurrent(null);
        setModalOpen(true);
    };

    const openView = (row) => {
        setCurrent(row);
        setModalOpen(true);
    };

    const handleSaveOwner = async (payload, id) => {
        if (!id) {
            // create needs contract_id
            if (!contract?.id) throw new Error('No active contract.');
            await createIdp({ ...payload, contract_id: contract.id });
        } else {
            await updateIdpOwner(id, payload);
        }
        await refresh();
    };

    const handleDelete = async (id) => {
        await deleteIdp(id);
        await refresh();
    };

    return (
        <>
            <Header label={<p className="py-0 my-0">My Individual Development Plan</p>} />
            <main id="main" className="main">
                <div className="row">
                    <div className="col-lg-12">

                        <div className="card">
                            <div className="card-header d-flex align-items-center">
                                <h5 className="fw-semibold">My IDPs</h5>
                                <div className="ms-auto">
                                    <button className="btn btn-primary btn-sm" onClick={openCreate} disabled={!contract}>
                                        + New IDP
                                    </button>
                                </div>
                            </div>
                            <div className="card-body">
                                {err && <div className="alert alert-danger">{err}</div>}
                                {loading ? (
                                    <div className="text-muted">Loading…</div>
                                ) : !rows?.length ? (
                                    <div className="text-muted">No IDPs yet.</div>
                                ) : (
                                    <div className="table-responsive reviews-table">
                                        <table className="table table-sm table-hover align-middle">
                                            <thead className="table-light">
                                            <tr>
                                                <th style={{ width: 60 }}>#</th>
                                                <th>Development Objective</th>
                                                <th>Competency</th>
                                                <th style={{ width: 140 }}>Target Date</th>
                                                <th style={{ width: 140 }} className="text-end">Actions</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {rows.map((r, idx) => (
                                                <tr key={r.id}>
                                                    <td>{String(idx + 1).padStart(2, '0')}</td>
                                                    <td className="text-truncate" title={r.development_objective}>{r.development_objective}</td>
                                                    <td className="text-truncate" title={r.competency_addressed}>{r.competency_addressed}</td>
                                                    <td>{(r.target_completion_date ?? '').slice(0, 10) || '—'}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-sm btn-outline-primary" onClick={() => openView(r)}>View</button>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                </div>
            </main>

            <IdpViewModal
                show={modalOpen}
                onClose={() => setModalOpen(false)}
                mode="owner"
                initial={current}
                onSaveOwner={handleSaveOwner}
                onSaveManager={async () => {}}
                onDelete={current?.id ? handleDelete : undefined}
                fetchOne={getIdp}
            />
        </>
    );
}